import React from "react";
import { Typography, Box, Button, Link, Stack } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../constants/RouteConstant";
import Price1 from "../assets/price1.png";
import Vector from "../assets/Vector.png";
import { useSiteState } from "../hookState/SiteState";
import Logo from "../assets/logo.png";
import { setProfileState } from "../hookState/ProfileState";
import { Footer } from "./Footer/Footer";
import Logo1 from "../assets/logo1.png";
import fb from "../assets/fb.png";
import insta from "../assets/insta.png";
import tiktok from "../assets/tiktok.png";
import yt from "../assets/yt.png";
import { setHeaderState } from "../hookState/HeaderState";

export const NewFooter = () => {
	const navigate = useNavigate();
	const state = useSiteState();

	const handlePayment = (price) => {
		navigate(RouteConstants.PAYMENT_GATEWAY, {
			state: { amount: price, type: "unlimited", cart: [] },
		});
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				width: "100%",
				zIndex: 3,
				// gap: 4,
				background: "#121926",
				// height: "520px",
				// width: "1376px",
				pt: 4,
				// height: "auto",
			}}
		>
			<Box
				sx={{
					width: { xs: "290px", md: "1280px" },
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignContent: "center",
					textAlign: "center",
					alignItems: "center",
					alignSelf: "center",
					// p: "20px 20px",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						// justifyContent: "space-between",
						// gap: { xs: 1, md: 0 },
						px: { xs: 2, md: 4 },
						background: "#0081FF",
						height: { xs: "300px", md: "108px" },
						borderRadius: 4,
						alignContent: "center",
						alignSelf: "center",
						width: { xs: "90%", md: "100%" },
					}}
				>
					<Box
						sx={{
							display: "flex",
							flexDirection: { xs: "column", md: "row" },
							width: { xs: "90%", md: "100%" },
							justifyContent: "space-between",
						}}
					>
						<Typography
							fontWeight={600}
							fontSize={{ xs: 22, md: 32 }}
							color="primary.main"
							textAlign={"left"}
						>
							{"Create your Account"}
						</Typography>
						<Box display={"flex"} flexDirection={"column"} gap={2}>
							{state.user.get() === "" && (
								<Button
									color="inherit"
									sx={{
										alignItems: "center",
										justifyContent: "center",
										my: "auto",
										color: "primary.main",
										bgcolor: "tertiary.main",
										px: { xs: 0, md: 2 },
										// mx: { xs: "-5px" },
										height: { xs: "23px", md: "32px" },
										width: "120px",
										borderRadius: 8,
										// width: { xs: "20px" },
									}}
									onClick={() => navigate(RouteConstants.SIGNUP)}
								>
									<Typography
										textTransform={"capitalize"}
										fontSize={{ xs: 10, md: 15 }}
										fontWeight={600}
										sx={{ textShadow: "1px 1px #000000" }}
									>
										Sign Up
									</Typography>
								</Button>
							)}
						</Box>
						<Typography
							fontWeight={600}
							fontSize={{ xs: 22, md: 32 }}
							color="primary.main"
							textAlign={"left"}
						>
							{"Unlock the Potential"}
						</Typography>
					</Box>
					<Box>
						<Typography
							fontWeight={500}
							fontSize={{ xs: 15, md: 18 }}
							color="primary.main"
							textAlign={"left"}
						>
							{
								"Unlock your potential by subscribing to Ecom Insider today! Gain the edge with daily insights on trending products, winning strategies, and real-time market moves. Whether you’re just starting out or scaling up, we’ll help you grow faster, smarter, and stronger. Success starts here—don’t miss your moment."
							}
						</Typography>
					</Box>
				</Box>

				<Box
					width={"100%"}
					height={{ xs: "auto", md: "200px" }}
					display={"flex"}
					flexDirection={{ xs: "column", md: "row" }}
					gap={4}
					p={2}
					borderBottom={1}
					borderColor={"#fff"}
				>
					<Box
						sx={{
							width: { xs: "100%", md: "40%" },
							display: "flex",
							justifyContent: "start",
						}}
					>
						<Box component={"img"} src={Logo1} height={50} width={221} />
					</Box>
					<Box
						sx={{
							width: { xs: "100%", md: "20%" },
							display: "flex",
							flexDirection: "column",
							gap: 2,
							justifyContent: "start",
							textAlign: "start",
							px: { xs: 2, md: 0 },
						}}
					>
						<Typography color="primary.main" fontSize={17}>
							Quick Links
						</Typography>
						<Box
							color="#D0D0D1"
							sx={{ cursor: "pointer" }}
							onClick={() => {
								navigate(RouteConstants.LANDING);
								setHeaderState("Home");

								setProfileState(false);
							}}
						>
							<Typography color="#D0D0D1" fontSize={17}>
								Home
							</Typography>
						</Box>
						<Box
							color="#D0D0D1"
							sx={{ cursor: "pointer" }}
							onClick={() => {
								navigate(RouteConstants.LANDING);

								setHeaderState("Pricing");
								setProfileState(false);
							}}
						>
							<Typography color="#D0D0D1" fontSize={17}>
								Pricing
							</Typography>
						</Box>
						<Box
							color="#D0D0D1"
							sx={{ cursor: "pointer" }}
							onClick={() => {
								navigate(RouteConstants.LANDING);

								setHeaderState("Blog");
								setProfileState(false);
							}}
						>
							<Typography color="#D0D0D1" fontSize={17}>
								Blog
							</Typography>
						</Box>
						<Box
							color="#D0D0D1"
							sx={{ cursor: "pointer" }}
							onClick={() => {
								navigate(RouteConstants.TOPSELLING);
								setHeaderState("Products");
								setProfileState(false);
							}}
						>
							<Typography color="#D0D0D1" fontSize={17}>
								Products
							</Typography>
						</Box>
					</Box>

					<Box
						sx={{
							width: { xs: "100%", md: "20%" },
							display: "flex",
							flexDirection: "column",
							gap: 2,
							justifyContent: "start",
							textAlign: "start",
							px: { xs: 2, md: 0 },
						}}
					>
						<Typography color="primary.main" fontSize={17}>
							Contact info
						</Typography>
						<Box
							color="#D0D0D1"
							sx={{ cursor: "pointer" }}
							onClick={() => {
								navigate(RouteConstants.CONTACT);
								setProfileState(false);
							}}
						>
							<Typography color="#D0D0D1" fontSize={17}>
								Contact Us
							</Typography>
						</Box>
						<Box
							color="#D0D0D1"
							sx={{ cursor: "pointer" }}
							onClick={() => {
								navigate(RouteConstants.LANDING);
								setHeaderState("Faq");
								setProfileState(false);
							}}
						>
							<Typography color="#D0D0D1" fontSize={17}>
								FAQ's
							</Typography>
						</Box>
					</Box>
					<Box
						sx={{
							width: { xs: "100%", md: "20%" },
							display: "flex",
							flexDirection: "column",
							gap: 2,
							justifyContent: "start",
							textAlign: "start",
							px: { xs: 2, md: 0 },
						}}
					>
						<Typography color="primary.main" fontSize={17}>
							Social Links
						</Typography>

						<Stack
							alignItems="center"
							direction="row"
							gap={1}
							sx={{ cursor: "pointer" }}
							onClick={() => {
								window.location =
									"https://www.facebook.com/profile.php?id=61570418488164";
							}}
						>
							<Box component={"img"} src={fb} height={20} width={20} />
							<Typography color="#D0D0D1" fontSize={17}>
								Facebook
							</Typography>
						</Stack>
						<Stack
							alignItems="center"
							direction="row"
							gap={1}
							sx={{ cursor: "pointer" }}
							onClick={() => {
								window.location = "https://www.instagram.com/ecom.insider.ltd/";
							}}
						>
							<Box component={"img"} src={insta} height={20} width={20} />
							<Typography color="#D0D0D1" fontSize={17}>
								Instagram
							</Typography>
						</Stack>
						<Stack
							alignItems="center"
							direction="row"
							gap={1}
							sx={{ cursor: "pointer" }}
							onClick={() => {
								window.location = "https://www.youtube.com/@ecominsider.n";
							}}
						>
							<Box component={"img"} src={yt} height={20} width={20} />
							<Typography color="#D0D0D1" fontSize={17}>
								YouTube
							</Typography>
						</Stack>
						<Stack
							alignItems="center"
							direction="row"
							gap={1}
							sx={{ cursor: "pointer" }}
							onClick={() => {
								window.location =
									"https://www.tiktok.com/@ecom_insider_ltd?lang=en";
							}}
						>
							<Box component={"img"} src={tiktok} height={20} width={20} />
							<Typography color="#D0D0D1" fontSize={17}>
								TikTok
							</Typography>
						</Stack>
					</Box>
				</Box>
			</Box>
			<Box
				sx={{
					display: "flex",
					flexDirection: { xs: "column-reverse", md: "row-reverse" },
					justifyContent: "space-between",
					height: "80px",
					width: { xs: "300px", md: "1280px" },
					// mx: { xs: 2, md: 5 },
					alignItems: "center",
					background: "#121926",
					alignContent: "center",
					alignSelf: "center",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: { xs: "row", md: "row" },
					}}
				>
					<Box onClick={() => navigate(RouteConstants.PRIVACY)}>
						<Typography
							color="initial"
							fontSize={14}
							paddingX={2}
							color={"#D0D0D1"}
						>
							Privacy Statement
						</Typography>
					</Box>
					<Box onClick={() => navigate(RouteConstants.CONTACT)}>
						<Typography
							color="initial"
							fontSize={14}
							paddingX={2}
							color={"#D0D0D1"}
						>
							Contact Us
						</Typography>
					</Box>
				</Box>
				<Box>
					<Typography fontSize={14} fontWeight={400} color={"#D0D0D1"}>
						Copyright &copy; 2022 Ecom Insider.
					</Typography>
				</Box>
			</Box>
		</Box>
	);
};
